import { Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import ClientFollowUp from "../../_shark_models/ClientFollowUp";
import ViewBase from "../ViewBase";

import templateContent from "./lead-list.html";

import { activityReportComponent } from "../../_shark_jaws/components/activityReportComponent";
import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import { clientFullRecapComponent } from "../visits/clientFullRecapComponent";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import contactFinderComponent from "../../components/contactFinder/contactFinderComponent";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import leadDetailsView from "./leadDetailsView";
import leadImportView from "./leadImportView";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import sampleRequestModalComponent from "../../components/sampleRequestModal/sampleRequestModalComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import visitEditView from "../visits/visitEditView";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class LeadListView extends ViewBase {
	constructor () {
		super("leadListView");

		this.setTemplate(templateContent);
	}

	afterRender () {
		$(`[data-toggle="popover"]`).popover({
			trigger: "focus",
		});
	}

	autoAgentMatchBtn_clickHandler () {
		const prospectList = Shark.get("prospectList");
		const agentList = Shark.get("agentList");
	
		prospectList.forEach(prospect => {
			if (prospect.status === 3) {
				const agent = agentList.find(agent => {
					return agent.preferences.zones !== undefined && agent.preferences.zones.indexOf(prospect.province) > -1;
				});
				
				if (agent) {
					prospect.set("__prospectAssignedAgentGuid", agent.guid);
				}
			}
		});
	
		Shark.render();
	}

	beforeLoad () {
		activityReportComponent.set("__reportType", "lead");
		liveSearchComponent.behavior = "database";
		followUpComponent.set("targetItem", null);
		sampleRequestModalComponent.set({
			referenceList: "prospectList",
			referenceType: "contact",
		});

		if (Shark.get("agentList").length === 0) {
			userManager.getList();
		}
		else {
			if (Shark.get("prospectList").length === 0 || Shark.get("forceProspectListRefresh")) {
				Shark.set("forceProspectListRefresh", false);
				this.refreshList();
			}
		}

		Shark.get("prospectList").selectedGuidList = [];

		exportCSVComponent.set({
			__exportCSVMultiExportList: [
				{
					exportType: "fullList",
					exportName: "Analisi Cantieri Lead",
					savedFileBaseName: "Analisi Cantieri Lead",
					exportMap: {
						name: "Lead",
						id: "leadFieldMap",
						fields: {
							name: "Riferimento Cantiere",
							__lotCount: "# Lotti",
							__presumedAmount: "Euro",
							["extraData.leadRequestedArea"]: "Mq",
							__lotsAreas: "Mq Lotti",
							__agentFullName: "Venditore",
							__premiseDestination: "Destinazione d'uso",
							__cscType: "Tipologia",
							__cscSystems: "Prodotto",
							province: "Provincia",
							__contactSourceLabel: "Origine Contatto",
						},
					},
				},
				{
					exportType: "leadReport",
					exportName: "Resoconto Lead",
					savedFileBaseName: "Resoconto Lead",
					replaceMaps: {
						"extraData.leadInterestSolutions": {
							1: "Pavimenti in resina",
							2: "Riqualificazione Pavimenti",
							3: "Pavimenti in Calcestruzzo",
							4: "Pavimentazione drenante in graniglia",
							5: "Pavimentazioni per aree ludiche e sportive",
							6: "Prodotti per il trattamento di strade naturali",
							7: "Pavimentazioni per la marina",
						},
					},
					exportMap: {
						name: "Lead",
						id: "leadListFieldMap",
						fields: {
							__leadRequestDateLabel: "Data Richiesta",
							name: "Azienda",
							["extraData.businessDescription"]: "Attività",
							sector: "Settore merceologico",
							__referenceLineLabel: "Interessato a",
							["extraData.leadInterestSolutions"]: "Interessato a - dettagli",
							["extraData.leadRequestedArea"]: "Mq",
							contactPerson: "Nome Cognome",
							email: "Email",
							phone: "Recapito telefonico",
							region: "Regione",
							province: "Provincia",
							city: "Città",
							__contactSourceLabel: "Origine Contatto",
							["extraData.leadIncomingMessage"]: "Richiesta*",
							__agentFullName: "Assegnazione",
							__activityStatusLabel: "Stato",
							__isTender: "Gara",
							__siteInfoSheetsCount: "Trattativa",
							__quotationsCount: "Preventivo",
							["quotationRefusedExtraData.refuseReason"]: "Motivazione per Preventivo rifiutato",
							__notInterestedForCSVExport: "Non interessato",
							__constructionSitesCount: "Cantieri",
						},
					},
				},
			],
		});

		exportPDFComponent.set("documentSaveName", "Tabella riassuntiva Lead per Agente e Provincia");
		// exportPDFComponent.set("documentToExport", null);

		this.set({
			__htmlTitle: "Lead | IPM HUB",
		});
	}

	// beforeRender () {
	// 	const prospectList = Shark.get("prospectList");
	
	// 	followUpComponent.set({
	// 		sourceList: prospectList
	// 	});
	// }

	createNewItemBtn_clickHandler () {
		contactFinderComponent.openModal("checkLead");

		return;
		const currProspect = Shark.getInstance("Client", {
			activityStatus: 1,
			enabled: true,
			status: 3
		});
	
		followUpComponent.set("targetItem", currProspect);
	
		Shark.set({
			currProspect,
			isEditingProspect: true,
			isNewProspect: true
		});
	
		Shark.openPage(leadDetailsView);
	}


	clientManager_contactSelectedHandler (event, data) {
		console.log({event, data});
	}

	init () {
		this.addComponents([activityReportComponent, agentFilterComponent, clientFullRecapComponent, contactFinderComponent, dateRangeFilterComponent, exportCSVComponent, exportPDFComponent, followUpComponent, getMoreComponent, liveSearchComponent, mainNavComponent, printButtonComponent, provinceFilterComponent, refreshListButtonComponent, sampleRequestModalComponent, waitBoxComponent]);
	
		const filtersStatus = this.getFiltersStatus();

		const prospectListActiveFilters = Shark.getInstance("__smart__", {
			contactSource: "0",
			notFlaggedCount: filtersStatus ? filtersStatus.notFlaggedCount : true,
			showBecomedClient: filtersStatus ? filtersStatus.showBecomedClient : false,
			showIsPremium: filtersStatus ? filtersStatus.showIsPremium : true,
			showIsTender: filtersStatus ? filtersStatus.showIsTender : true,
			showLead: filtersStatus ? filtersStatus.showLead : true,
			showNotFlagged: filtersStatus ? filtersStatus.showNotFlagged : true,
			showNotInterested: filtersStatus ? filtersStatus.showNotInterested : true,
			showProspect: filtersStatus ? filtersStatus.showProspect : false,
			showReportCompiled: filtersStatus ? filtersStatus.showReportCompiled : true,
			showSentDocumentation: filtersStatus ? filtersStatus.showSentDocumentation : true,
			showSISCreated: filtersStatus ? filtersStatus.showSISCreated : true,
			showUnassigned: filtersStatus ? filtersStatus.showUnassigned : true,
			showWaiting: filtersStatus ? filtersStatus.showWaiting : true,

			showWithNewFollowUp: filtersStatus ? filtersStatus.showWithNewFollowUp : true,
			showWithoutNewFollowUp: filtersStatus ? filtersStatus.showWithoutNewFollowUp : true,
		});
		
		prospectListActiveFilters.on("dataChanged", function () {
			leadListView.saveFiltersStatus(this);

			if (this.showBecomedClient || this.showNotInterested || this.showReportCompiled || this.showSISCreated || this.showUnassigned || this.showWaiting) {
				leadListView.refreshList();
			}
			else {
				Shark.render();
			}
		});
	
		const prospectCheckedList = Shark.getInstance(null, { selectedGuidList: [] });
	
		prospectCheckedList.on("dataChanged", (event) => {
			const selectedGuidList = event.target.selectedGuidList;
			if (selectedGuidList.length > 0) {
				document.querySelectorAll(".deleteSelectedBtn").forEach(item => item.disabled = false);
			}
			else {
				document.querySelectorAll(".deleteSelectedBtn").forEach(item => item.disabled = true);
			}
		});
	
		Shark.set({
			agentList: Shark.get("agentList") || [],
			prospectCheckedList,
			prospectList: Shark.get("prospectList") || [],
			prospectListActiveFilters
		});
	
		// pagerComponent.set({
		// 	currPage: 0,
		// 	pageSize: 500
		// });
	}
	
	importProspectListBtn_clickHandler () {
		Shark.openPage(leadImportView);
	}

	prepareSingleDataSetExport (dataSetName) {
		waitBoxComponent.open();

		return new Promise((resolve) => {
			// const prospectListActiveFilters = Shark.get("prospectListActiveFilters");
			// prospectListActiveFilters.exportDataSetToInclude = dataSetName;

			const prospectList = Shark.get("prospectList");
			const guidList = prospectList.map(item => item.guid);
			
			if (dataSetName === "fullList") {
				clientManager.getListByGuidList(guidList)
				.then(getResponse => {	
					const contactList = getResponse.data.contactList;
					
					getResponse.data.rawData.forEach(item => {
						if (item.quotationLots) {

							const contact = Utils.safp(contactList, "guid", item.guid);

							if (contact) {
								contact.quotationLots = Utils.parseJSON(item.quotationLots);
								contact.__cscType = item.cscType;

								contact.__cscSystems = Utils.parseJSON(item.cscSystems);
								contact.__premiseDestination = contact.__cscSystems.reduce((sum, item) => {
									return item.premiseDestination.trim() !== "" ? sum + ", " + item.premiseDestination : sum;
								}, "");

								contact.__cscSystems = contact.__cscSystems.reduce((destinationSum, destination) => {
									return destination.systems.reduce((sum, item) => {
										return item.system.trim() !== "" ? sum + ", " + item.system : sum;
									}, destinationSum);
								}, "");

								if (contact.__premiseDestination.trim() !== "") {
									contact.__premiseDestination = contact.__premiseDestination.substr(2);
								}
								if (contact.__cscSystems.trim() !== "") {
									contact.__cscSystems = contact.__cscSystems.substr(2);
								}
								

								contact.__presumedAmount = contact.quotationLots.reduce((sum, item) => {
									return sum + item.expetedAmount;
								}, 0);

								contact.__lotsAreas = contact.quotationLots.reduce((sum, item) => {
									return item.area.trim() !== "" ? sum + ", " + item.area : sum;
								}, "");

								if (contact.__lotsAreas.trim() !== "") {
									contact.__lotsAreas = contact.__lotsAreas.substr(2);
								}

								contact.__lotCount = contact.quotationLots.length;
								console.log({item, contact});
							}
						}
					});
					console.log("prepareSingleDataSetExport", {dataSetName, guidList, getResponse});
					
					waitBoxComponent.close();
					resolve(contactList);
				});

			}
			else if (dataSetName === "leadReport") {
				clientManager.getListByGuidList(guidList)
				.then(getResponse => {
					const contactList = getResponse.data.contactList;
					
					getResponse.data.rawData.forEach(item => {
						const contact = Utils.safp(contactList, "guid", item.guid);
						
						if (item.quotationsCount && contact) {
							contact.__quotationsCount = parseInt(item.quotationsCount) === 0 ? "" : "X (" + item.quotationsCount + ")";
						}
						if (item.siteInfoSheetsCount && contact) {
							contact.__siteInfoSheetsCount = parseInt(item.siteInfoSheetsCount) === 0 ? "" : "X (" + item.siteInfoSheetsCount + ")";
						}
						if (item.constructionSitesCount && contact) {
							contact.__constructionSitesCount = parseInt(item.constructionSitesCount) === 0 ? "" : "X (" + item.constructionSitesCount + ")";
						}

					});
					console.log("prepareSingleDataSetExport", {dataSetName, guidList, getResponse});
					
					contactList.forEach(item => {
						item.__isTender = item.extraData.leadIsTender ? "X" : "";
					});
					
					waitBoxComponent.close();
					resolve(contactList);
				});

			}
			else {
				waitBoxComponent.close();
				resolve(prospectList);
			}
		});
	}

	prospectActionBtn_clickHandler (event, data) {
		const selectedProspect = Utils.safp(Shark.get("prospectList"), "guid", data.guid);
	
		switch(data.action) {
			case "archive": {
				const meessage = prompt("Sei sicuro di voler archiviare il lead selezionato?\nPer favore inserisci una motivazione:");
				if (meessage) {
					selectedProspect.status = 8;
					selectedProspect.extraData.archiveReason = meessage;
					clientManager.updateProspect([selectedProspect]);
				}
				break;
			}
			case "delete":
				if (confirm("Sei sicuro di voler cancellare il lead selezionato?")) {
					clientManager.deleteProspect([selectedProspect]);
				}
				break;
			case "promote":
				if ((selectedProspect.name.trim() !== "" && selectedProspect.code.trim() !== "") || confirm("Per il lead selezionato non è stato impostato il nome azienda o il codice, sei sicuro di voler procedere?")) {
					selectedProspect.status = 1;
					clientManager.updateProspect([selectedProspect]);
				}
				break;
			case "setAsNotInterested":
				if (confirm(`Sei sicuro di voler segnare il Lead "${selectedProspect.name}" come "Non Interessato"?`)) {
					const reason = prompt("Per favore inserisci una motivazione (obbligatorio)");

					if (reason.trim() !== "") {
						waitBoxComponent.open();

						selectedProspect.set({
							activityStatus: 9,
							["extraData.leadNotInterestedReason"]: reason || "",
						});

						clientManager.setLeadAsNotInterested([selectedProspect])
						.then(() => {
							const newFollowUp = new ClientFollowUp({
								body: `Il Lead <strong>${selectedProspect.name}</strong> è stato impostato come <strong>Non Interessato</strong>.${reason ? " È stata aggiunta la seguente motivazione: <q>" + reason + "</q>" : ""}`,
								clientGuid: selectedProspect.guid,
								referenceGuid: selectedProspect.guid,
								referenceType: "client",
								status: 3,
								type: "system",
							});
							
							followUpManager.save(newFollowUp)
							.then(followUpSaveResponse => {
								console.log({followUpSaveResponse});
								waitBoxComponent.close();
								this.refreshList();
							});
						});
					}
					else {
						alert("Non hai inserito una motivazione, non posso procedere!");
					}
				}
				break;
		}
	}
	
	refreshList (range = null) {
		waitBoxComponent.show();

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const { agentFilter, dateRangeFilter, prospectListActiveFilters, provinceFilter } = Shark.get();
		const filters = prospectListActiveFilters.export();

		if (parseInt(filters.contactSource) === 0) {
			delete filters.contactSource;
		}

		delete filters.becomeClientCount;
		delete filters.isPremiumCount;
		delete filters.isTenderCount;
		delete filters.notFlaggedCount;
		delete filters.notInterestedCount;
		delete filters.reportCompiledCount;
		delete filters.sentDocumentationCount;
		delete filters.unassignedCount;
		delete filters.waitingCount;

		if (provinceFilter.province !== "all") {
			filters.province = provinceFilter.province;
		}

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}
		else {
			delete filters.dateFrom;
			delete filters.dateTo;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		return clientManager.getFilteredLeadList({filters, range, incrementalRequest}, true)
		.then(response => {
			const provinceForFilterComponentSet = new Set();
			response.data.forEach(item => provinceForFilterComponentSet.add(item.province));

			//Dave: Spostalo nel componente
			let provinceForFilterComponent = Array.from(provinceForFilterComponentSet);
			provinceForFilterComponent.sort();
			provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});

			waitBoxComponent.hide();
			Shark.set({provinceForFilterComponent});
			Shark.render();
			return true;
		});
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				name: searchKey,
				contactPerson: searchKey,
				searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}

	userManager_listChangedHandler () {
		//Dave: gli handler sui manager hanno il this sbagliato
		if (Shark.get("prospectList").length === 0 || Shark.get("forceProspectListRefresh")) {
			Shark.set("forceProspectListRefresh", false);
			leadListView.refreshList();
		}
	}



	
	afterComponentsPreRender () {
		//Dave.ToDo: Questo non dovrà più esistere: quando ricevo i dati li gestisco, li passo agli eventuali componenti, e buona così.
		let prospectList = Shark.get("prospectList");

		if (prospectList) {
			// const [agentFilter, dateRangeFilter, prospectListActiveFilters, provinceFilter] = Shark.get(["agentFilter", "dateRangeFilter", "prospectListActiveFilters", "provinceFilter"]);
			let counter = 0;

			
			prospectList.forEach((item, index) => {
				item.__index = index;//Dave:Warn: L'index deve restare fuori perché in questa tabella c'è un riferimento al model e se l'index si sfasa punta a quello sbagliato. (in prospectList ci sono TUTTI non solo quelli renderizzati)
				item.__displayIndex = counter + 1;
				counter++;
			});
			// console.log("afterComponentsPreRender", {prospectList, prospectListActiveFilters});
		}

		exportCSVComponent.set({
			listToExport: prospectList.filter(item => item.__render)
		});

		Shark.set({
			activityReport: activityReportComponent.extractReport(prospectList),
		});

		followUpComponent.set({
			sourceList: prospectList
		});
	}


	deleteSelectedBtn_clickHandler () {
		if (confirm("Sei sicuro di voler cancellare i prospect selezionati?\nSe procedi non sarà possibile recuperarli.")) {
			const prospectList = Shark.get("prospectList");
			const selectedGuidList = Shark.get("prospectCheckedList").selectedGuidList;
			const prospectToDeleteList = prospectList.filter(item => selectedGuidList.indexOf(item.guid) > -1);

			// console.log({ selectedGuidList, prospectToDeleteList});

			clientManager.deleteProspect(prospectToDeleteList);
			Shark.get("prospectCheckedList").selectedGuidList = [];
		}
	}

	openReportBtn_clickHandler (event, data) {
		const selectedLead = Utils.safp(Shark.get("prospectList"), "guid", data.guid);

		if (selectedLead) {
			visitManager.getByProspect(selectedLead)
			.then(() => {
				Shark.openPage(visitEditView);
			});
		}
	}


	saveAgentMatchingBtn_clickHandler () {
		//Dave: bisognerebbe fare un FU che dica che è stato assegnato all'agente
		if (confirm("Sei sicuro di voler salvare l'assegnazione corrente?\nSe procedi non potrai annullare.")) {
			// const prospectList = Shark.get("prospectList");
			const prospectListToSave = Shark.get("prospectList").filter(item => item.isDirty());
			prospectListToSave.forEach(item => item.agentAssignmentDate = moment());
			console.log({prospectListToSave});
			if (prospectListToSave.length > 0) {
				clientManager.saveProspectList(prospectListToSave);
			}
		}
	}

	selectAllChk_clickHandler () {
		const selectAllChk = document.querySelector("#selectAllChk");
		const allDeleteCheckboxes = document.querySelectorAll(".deleteProspectInput");
		const selectedGuidList = [];

		allDeleteCheckboxes.forEach(item => {
			selectedGuidList.push(item.value);
			item.checked = selectAllChk.checked;
		});

		Shark.get("prospectCheckedList").selectedGuidList = selectedGuidList;

		document.querySelectorAll(".deleteSelectedBtn").forEach(item => item.disabled = !selectAllChk.checked);
		// const deleteSelectedBtn = document.querySelectorAll(".deleteSelectedBtn").forEach(item => item.disabled = !selectAllChk.checked);
	}

	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}
		if (event.target.classList.contains("notClickable")) {
			return;
		}

		const selectedProspect = Utils.safp(Shark.get("prospectList"), "guid", data.guid);

		if (selectedProspect) {
			followUpComponent.set("targetItem", selectedProspect);
			Shark.set({
				currProspect: selectedProspect,
				isEditingProspect: false,
				isNewProspect: false,
			});
			Shark.openPage(leadDetailsView);
		}
	}
}

// const visitList = Shark.get("visitList");
const leadListView = new LeadListView();

Shark.registerView(leadListView);

export default leadListView;
